import React, { type PropsWithChildren } from 'react'

type AccordionListType = React.FC<PropsWithChildren>

export const AccordionList: AccordionListType = ({ children, ...props }) => (
  <div
    className="mx-auto flex flex-col group-[.is-blue]/section-template:max-w-[48.5rem] group-[.is-gradient]/section-template:max-w-[48.5rem] group-[.is-grey]/section-template:max-w-[48.5rem] group-[.is-white]/section-template:max-w-[48.5rem]"
    {...props}
  >
    {children}
  </div>
)
